module.exports = __webpack_public_path__ + "img/Triangulum.1fc63a81.png";